type MessageObject = {
  code: string
  message: string
}

export const handleErrorsMessage = (
  message: string,
  messages: MessageObject[] = []
) => messages[0]?.message || message
